import React from 'react';

import {
    registerResizeHandler,
    unregisterResizeHandler
} from '../../utils/resize-handler';
import styles from './ChartWrapper.css';

class ChartWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.chartContainer = React.createRef();
        this.tooltip = React.createRef();
        this.state = {
            width: 800,
            height: 400,
            marginLeft: 65,
            marginBottom: 25,
            tipActive: false,
            tipData: { label: '', headers: [''], data: [''] },
            mouseX: 0,
            mouseY: 0,
            tipOffsetX: 0,
            tipOffsetY: 0
        };
    }

    componentDidMount() {
        registerResizeHandler(this.updateDimensions);
        // eslint-disable-next-line
        this.updateDimensions();
    }

    componentDidUpdate(prevProps, prevState) {
        const { width } = prevState;
        const {
            current: { offsetWidth }
        } = this.chartContainer;
        const {
            current: { offsetWidth: tipWidth, offsetHeight: tipHeight }
        } = this.tooltip;
        const { mouseX } = this.state;
        // Calculate tip offset only when tip data changes
        if (prevState.tipData.label !== this.state.tipData.label) {
            const oX =
                mouseX + tipWidth > offsetWidth - 25 ? -tipWidth - 15 : 15;
            const oY = -tipHeight / 2;
            // eslint-disable-next-line
            this.setState({
                tipOffsetX: oX,
                tipOffsetY: oY
            });
        }
        if (width !== offsetWidth) {
            // eslint-disable-next-line
            this.setState({
                width: offsetWidth
            });
        }
    }

    componentWillUnmount() {
        unregisterResizeHandler(this.updateDimensions);
    }

    updateDimensions = () => {
        const {
            current: { offsetWidth: width, offsetHeight: height }
        } = this.chartContainer;
        // TODO expand this
        if (width < 400) {
            this.setState({ height, width, marginLeft: 0 });
        } else {
            this.setState({ height, width, marginLeft: 50 });
        }
    };

    updateTooltip = (x, y, data, active) => {
        const { tipActive } = this.state;
        if (active || tipActive) {
            const update = {
                mouseX: x,
                mouseY: y,
                tipData: data.data
            };
            if (active) {
                update.tipActive = true;
            }

            this.setState(update);
        }
    };

    toggleTooltip = (bool) => {
        this.setState({ tipActive: bool });
    };

    render() {
        const {
            marginBottom,
            marginLeft,
            mouseX,
            mouseY,
            height,
            width,
            tipActive,
            tipData,
            tipOffsetX,
            tipOffsetY
        } = this.state;
        const { children, tipContent } = this.props;
        const { toggleTooltip, updateTooltip } = this;
        return (
            <div ref={this.chartContainer} className="chart-container">
                {children({
                    width,
                    height,
                    marginLeft,
                    marginBottom,
                    toggleTooltip,
                    updateTooltip
                })}
                {
                    <div
                        className="tooltip"
                        ref={this.tooltip}
                        style={{
                            position: 'absolute',
                            top: mouseY + tipOffsetY,
                            left: mouseX + tipOffsetX,
                            display: tipActive ? 'block' : 'none'
                        }}
                    >
                        {typeof tipContent === 'function' &&
                            tipContent(tipData)}
                    </div>
                }

                <style jsx>{styles}</style>
            </div>
        );
    }
}

export default ChartWrapper;
